import { render, staticRenderFns } from "./AddUpdateReleaseNotes.vue?vue&type=template&id=f6968b9c"
import script from "./AddUpdateReleaseNotes.vue?vue&type=script&lang=js"
export * from "./AddUpdateReleaseNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.24_css-loader@6.11.0_webpack@5.103.0__lodash@4_02e380aa463220c29513590f381609d6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports